import { createFileRoute } from '@tanstack/react-router'

import { RegisterPasswordPage } from '@/pages/RegisterPasswordPage'

export const Route = createFileRoute('/register-password')({
  component: RouteComponent,
})

function RouteComponent() {
  return <RegisterPasswordPage />
}
